import { QueryClient, QueryClientConfig } from 'react-query'

const createQueryClient = (config?: QueryClientConfig) => {
  return new QueryClient(config)
}

export default createQueryClient
